import React, {useState} from "react";
import {TemplateWithoutBody} from "../../model/Template";
import TemplateTable from "../Template/TemplateTable";
import {Button, Card, TextField, Box} from "@mui/material";
import {Form, json, redirect, useSubmit} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {updateDemoConfig} from "../../api/demoConfigClient";

interface Props {
    templates: TemplateWithoutBody[],
    demoTemplateIds: string[],
    courseUrl?: string,
    courseName?: string
}

export const DemoConfigEditor: React.FC<Props> = (props) => {

    const [selectedTemplateIds, setSelectedTemplateIds] = useState(props.demoTemplateIds)
    const [courseUrl, setCourseUrl] = useState(props.courseUrl || "")
    const [courseName, setCourseName] = useState(props.courseName || "")

    const submit = useSubmit()
    const {t} = useTranslation()

    const handleSelectionChange = (newSelection: string[]) => {
        setSelectedTemplateIds(newSelection)
    }

    return (
        <>
            <Card>
                <Form method={"put"}>
                    <Box sx={{ p: 2 }}>
                        <TextField
                            fullWidth
                            label={t('demoConfig.courseName') || 'Course Name'}
                            name="courseName"
                            value={courseName}
                            onChange={(e) => setCourseName(e.target.value)}
                            margin="normal"
                            helperText={t('demoConfig.courseNameHint') || 'Enter the name for the demo course'}
                        />
                        <TextField
                            fullWidth
                            label={t('demoConfig.courseUrl') || 'Course URL'}
                            name="courseUrl"
                            value={courseUrl}
                            onChange={(e) => setCourseUrl(e.target.value)}
                            margin="normal"
                            helperText={t('demoConfig.courseUrlHint') || 'Enter the URL for the demo course'}
                        />
                    </Box>
                    <TemplateTable templates={props.templates} selectedTemplateIds={selectedTemplateIds}
                                   onSelectionChange={handleSelectionChange}/>
                    {selectedTemplateIds.map((id, index) => {
                        return <input
                            key={index}
                            type="hidden"
                            name="selectedTemplate"
                            value={id}
                        />
                    })}
                    <input type="hidden" name="courseUrl" value={courseUrl} />
                    <input type="hidden" name="courseName" value={courseName} />
                    <Button type="submit" variant="contained">
                        {t('customerEditor.save')}
                    </Button>
                </Form>
            </Card>
        </>
    )
}

export async function action({request, params}: { request: Request, params: any }) {
    const data = await request.formData();
    const templateIds = data.getAll('selectedTemplate') as string[]
    const courseUrl = data.get('courseUrl') as string
    const courseName = data.get('courseName') as string

    const response = await updateDemoConfig(params.customerId, {
        demoTemplateIds: templateIds,
        courseUrl: courseUrl || undefined,
        courseName: courseName || undefined
    })

    if (!response.ok) {
        throw json({message: 'Could not update demo config'}, {status: response.status});
    } else {
        return redirect('..');
    }
}